import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig, AppConfiguration } from 'src/configuration';
import { Router } from '@angular/router';


@Injectable({
    providedIn: 'root',
})

export class TimeTableDetailService {

    constructor(
        @Inject(AppConfig) private readonly appConfig: AppConfiguration,
        private router: Router,
        private http: HttpClient
      ) {}

    getGeneration(): Observable<any> {
        return this.http.get<any>(this.appConfig.UniSystemAPI + 'He/Danh_sach_he').pipe(map((z) => { return z; }));
    }

    getDepartment(): Observable<any> {
        return this.http.get<any>(this.appConfig.UniSystemAPI + 'Khoa/Danh_sach_khoa').pipe(map((z) => { return z; }));
    }

    getSchoolYear(): Observable<any> {
        return this.http.get<any>(this.appConfig.UniSystemAPI + 'Core/KhoaHoc_Load_List').pipe(map((z) => { return z; }));
    }

    getMajor(): Observable<any> {
        return this.http.get<any>(this.appConfig.UniSystemAPI + 'ChuyenNganh/Danh_sach_chuyen_nganh').pipe(map((z) => { return z; }));
    }

    getClass(): Observable<any> {
        return this.http.get<any>(this.appConfig.UniSystemAPI + 'Lop/Danh_sach_lop_dang_hoc').pipe(map((z) => { return z; }));
    }

    getWeek(req: any): Observable<any> {
        return this.http.post<any>(this.appConfig.UniLeader + 'ThoiKhoaBieu/KeHoachTuanGet', req).pipe(map((z) => { return z; }));
    }

    getYear(): Observable<any> {
        return this.http.get<any>(this.appConfig.UniLeader + 'ThoiKhoaBieu/KeHoachNamGetAll').pipe(map((z) => { return z; }));
    }

    getTimeTable(req: any): Observable<any> {
        return this.http.post<any>(this.appConfig.UniLeader + 'ThoiKhoaBieu/KeHoachTuanGetDetail', req).pipe(map((z) => { return z; }));
    }

    getScheduleNow(): Observable<any> {
        return this.http.get<any>(this.appConfig.UniLeader + 'ThoiKhoaBieu/WeekDayGetNow').pipe(map((z) => { return z; }));
    }

    exportExcel(req: any): Observable<any> {
        return this.http.post<any>(this.appConfig.UniLeader + 'ThoiKhoaBieu/ExportExcel', req).pipe(map((z) => { return z; }));
    }
}